import { render, staticRenderFns } from "./ResidentCollectionHistoryModal.vue?vue&type=template&id=baf03758&scoped=true&"
import script from "./ResidentCollectionHistoryModal.vue?vue&type=script&lang=ts&"
export * from "./ResidentCollectionHistoryModal.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentCollectionHistoryModal.vue?vue&type=style&index=0&id=baf03758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf03758",
  null
  
)

export default component.exports